import { render, staticRenderFns } from "./ChannelGenre.vue?vue&type=template&id=6416f65e&scoped=true&"
import script from "./ChannelGenre.vue?vue&type=script&lang=js&"
export * from "./ChannelGenre.vue?vue&type=script&lang=js&"
import style0 from "./ChannelGenre.vue?vue&type=style&index=0&id=6416f65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6416f65e",
  null
  
)

export default component.exports